import React, { Component } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { push } from 'connected-react-router';
import Shop from '../shop/Shop';
import { fetchCategories, fetchBrands } from '../../redux/actions/categories';
import RTVLoading from '../../commons/RTVLoading';
import { BRANDS_FAILED, BRANDS_RETRIEVED } from '../../redux/actions/types';
import normalizeString from '../../utils/normalizeString';
import { Helmet } from 'react-helmet';
import { Typography, withStyles } from '@material-ui/core';

const translateFilter = filter => {
  switch (filter) {
    case 'lo-recien-publicado':
      return 'new';
    default:
      return undefined;
  }
};

const PromoArray = [
  'THREE_FOR_TWO',
  'TWO_FOR_ONE',
  'TWENTY_PERCENT',
  'THIRTY_PERCENT',
  'FORTY_PERCENT'
];

class ProductsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadedBrands: false,
      params: {
        promos: props.customFilter === 'en-promo-hoy' ? PromoArray : undefined,
        category: props.category ? encodeURI(props.category) : null,
        subCategory: props.subCategory ? encodeURI(props.subCategory) : null,
        subSubCategory: props.subSubCategory
          ? encodeURI(props.subSubCategory)
          : null,
        // We actually have to fetch brands and try to find a brand with the
        // name of the brand from props. If no brand found, empty it.
        brand: props.brand,
        // If the customFilter has a customSort, we have it set on the `translateFilter`
        // function.
        sort:
          props.customFilter !== undefined
            ? translateFilter(props.customFilter)
            : undefined
      }
    };
  }

  componentDidMount() {
    if (this.props.brand) {
      this.props.fetchBrands();
    }
  }

  componentDidUpdate(prevProps) {
    if (!lodash.isEqual(prevProps.match.params, this.props.match.params)) {
      this.setState({
        params: {
          promos:
            this.props.customFilter === 'en-promo-hoy' ? PromoArray : undefined,
          category: this.props.category ? encodeURI(this.props.category) : null,
          subCategory: this.props.subCategory
            ? encodeURI(this.props.subCategory)
            : null,
          subSubCategory: this.props.subSubCategory
            ? encodeURI(this.props.subSubCategory)
            : null,
          brand: this.props.brand,
          sort:
            this.props.customFilter !== undefined
              ? translateFilter(this.props.customFilter)
              : undefined
        }
      });
    }

    if (prevProps.status !== this.props.status) {
      if (
        this.props.status === BRANDS_RETRIEVED ||
        this.props.status === BRANDS_FAILED
      ) {
        this.setState({
          loadedBrands: true
        });
      }
    }
  }

  render() {
    const { hashedCategories, favorites, classes } = this.props;
    const {
      category,
      subCategory,
      subSubCategory,
      promos,
      sort,
      brand
    } = this.state.params;

    if (!Object.keys(hashedCategories).length) {
      return <div style={{ minHeight: '100vh' }} />;
    }

    if (
      (this.state.mostWatchedFilter || this.props.brand) &&
      !this.state.loadedBrands
    ) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <RTVLoading
            message={
              this.state.mostWatchedFilter
                ? 'Buscando las mejores marcas...'
                : 'Buscando marcas...'
            }
          />
        </div>
      );
    }

    const brandObject = brand
      ? this.props.brands.find(
          b => normalizeString(b.name) === normalizeString(brand)
        )
      : undefined;

    if (
      (category && hashedCategories[category] === undefined) ||
      (subCategory &&
        hashedCategories[category].sub_categories[subCategory] === undefined) ||
      (subSubCategory &&
        hashedCategories[category].sub_categories[subCategory]
          .sub_sub_categories[subSubCategory] === undefined) ||
      (brand && brandObject === undefined)
    ) {
      return <Redirect to={{ pathname: '/productos/404' }} />;
    }

    let title = 'Tienda | Renová Tu Vestidor';
    let description =
      'Encontrá ropa genial de las mejores marcas en Renová Tu Vestidor a precios increíbles. Comprá segura y recibilo en tu casa.';
    if (subSubCategory && brand) {
      const subSubObject =
        hashedCategories[category].sub_categories[subCategory]
          .sub_sub_categories[subSubCategory];
      title = `${subSubObject.name} - ${brandObject.name} | Renová Tu Vestidor`;
      description = `Encontrá ${subSubObject.name} de ${brandObject.name} en Renová Tu Vestidor a precios increíbles. Comprá segura y recibilo en tu casa.`;
    } else if (subSubCategory) {
      const subSubObject =
        hashedCategories[category].sub_categories[subCategory]
          .sub_sub_categories[subSubCategory];
      title = `${subSubObject.name} | Renová Tu Vestidor`;
      description = `Encontrá ${subSubObject.name} en Renová Tu Vestidor a precios increíbles. Comprá segura y recibilo en tu casa.`;
    } else if (brand) {
      title = `Tienda ${brandObject.name} | Renová Tu Vestidor`;
      description = `Encontrá lo mejor de ${brandObject.name} en Renová Tu Vestidor a precios increíbles. Comprá segura y recibilo en tu casa.`;
    }

    return (
      <div style={{ minHeight: '100vh' }}>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta property="og:type" content="website" />
          <meta property="og:description" content={description} />
          <meta
            property="og:image"
            content="https://cdn.renovatuvestidor.com/mktg/referidos_facebook.jpg"
          />
          <meta name="title" content={title} />
          <meta name="description" content={description} />
        </Helmet>
        {favorites && (
          <div className={classes.message}>
            <Typography className={classes.messageTypography}>
              MIS FAVORITOS
            </Typography>
          </div>
        )}
        <Shop
          favorites={favorites}
          errorMessage={this.props.errorMessage}
          defaultFilter={{
            category: category ? [hashedCategories[category].id] : undefined,
            sub_category: subCategory
              ? [hashedCategories[category].sub_categories[subCategory].id]
              : undefined,
            sub_sub_category: subSubCategory
              ? [
                  hashedCategories[category].sub_categories[subCategory]
                    .sub_sub_categories[subSubCategory].id
                ]
              : undefined,
            promo: promos,
            brand: brand
              ? [
                  this.props.brands.find(
                    b => normalizeString(b.name) === normalizeString(brand)
                  )?.id
                ]
              : undefined,
            sort: sort || (favorites ? 'added_favorites_desc' : '')
          }}
        />
      </div>
    );
  }
}

const styles = theme => ({
  message: {
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  messageTypography: {
    fontSize: '0.9rem !important',
    fontWeight: 500
  }
});

const mapStateToProps = state => ({
  hashedCategories: state.categories.hashedCategories,
  status: state.categories.status,
  brands: state.categories.brands
});

const mapDispatchToProps = dispatch => ({
  fetchCategories: () => dispatch(fetchCategories()),
  fetchBrands: filter => dispatch(fetchBrands(filter)),
  push: path => dispatch(push(path))
});

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductsList))
);
